export const ACCESS_TOKEN_STORAGE = "access_token";
export const EXPIRES_AT_STORAGE = "expires_at";
export const USERNAME_STORAGE = "username";
export const USER_STORAGE = "user";
export const NOTIFICATION_STORAGE = "notifications";


// WEBPACK FOOTER //
// ./src/constants/storageConstants.js